// libs
import React from 'react'

// components
import Icon from 'src/components/forms/icon/icon'
import Modal from 'src/components/modal/modal'

// constants
import { CLASS_PREFIX } from 'src/constants'

// styles
import { COLOR_TYPE_WHITE } from 'src/utils/color'

import { useHistory } from 'react-router-dom'
import NavigationItem from 'src/components/navigation_item/navigation_item'
import { textResources } from 'src/lang/de'
import '../project_modal.scss'

type IProps = {
  onClose: () => void;
  projectHref?: string;
  customClassNames?: string;
};

const cls = `${CLASS_PREFIX}project-modal`

const t = textResources.projects

export const ProjectsCreateSuccessModal: React.FC<IProps> = ({
  onClose,
  projectHref
}) => {
  const history = useHistory()

  return (
    <Modal autoSize onClose={onClose} customClassNames={`${cls}`}>
      <div className={`${cls}__body`}>
        <div className={`${cls}__check`}>
          <Icon name="check" size={22} color={COLOR_TYPE_WHITE} />
        </div>
        <h3 className={`${cls}__title`}>{t.createProjectSuccessModal.title}</h3>
        <p className={`${cls}__text`}>{t.createProjectSuccessModal.text}</p>

        <div className={`${cls}__actions`}>
          <NavigationItem onClick={() => projectHref && history.push(projectHref)} className={`${cls}__primary`} onClick={onClose}>
            {t.createProjectSuccessModal.goToMyProjectPage}
          </NavigationItem>

          <button
            className={`${cls}__secondary`}
            type="button"
            onClick={onClose}
          >
            <span>{t.createProjectSuccessModal.backToProjects}</span>
          </button>
        </div>
      </div>
    </Modal>
  )
}
